module.exports = __webpack_public_path__ + "fonts/nunito-sans-v11-latin-200.18e0d9fb.woff";